import React, { useState, useMemo, useEffect } from "react";
import * as Icon from "react-feather";
import { useSelector, useDispatch } from "react-redux";
import { Nav, NavLink, NavItem, Collapse } from "reactstrap";
import { useLocation, Link, useNavigate } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { logout } from "../../../slices/authSlice/userSilce";
import { ToggleMobileSidebar } from "../../../store/customizer/CustomizerSlice";


/* eslint-disable */

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobileSidebar = useSelector((state) => state.customizer.isMobileSidebar);
  const { user: currentUser } = useSelector((state) => state.user);
  const activeBg = useSelector((state) => state.customizer.sidebarBg);
  const isFixed = useSelector((state) => state.customizer.isSidebarFixed);

  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const handleLogoutClick = () => {
    dispatch(logout());
    navigate("/login", { replace: true });
    window.location.reload();
  };

  useEffect(() => {
    if (isMobileSidebar) {
      dispatch(ToggleMobileSidebar());
    }
  }, [location.pathname]);

  const menuConfig = useMemo(() => ({
    "6": [ // Retailer / Agent
      { title: "Dashboard", icon: <Icon.Home />, path: "/Dashboards/RetailerDashboard" },
      { title: "Agent Self Bank", icon: <Icon.User />, path: "/SelfBank/RetailorBankList" },
      { title: "AEPS Payout", icon: <Icon.Airplay />, path: "/Agent/AEPSPayout" },
      { title: "AEPS Wallet to DMT", icon: <Icon.MousePointer />, path: "/Agent/AEPSToDMTTransfer", },
      { title: "Agent Reports", icon: <Icon.List />, key: "agentReports",
        children: [
          { title: "Ledger Reports", path: "/Agent/LedgerReport",},
          { title: "Cashout Reports", path: "/Agent/CashoutTransaction" },
          { title: "MonyTransfer Reports", path: "/Agent/DMTTransactionReports" },
          { title: "MonyTransfer Hold Case Reports", path: "/Agent/MoneyTransferHoldCases" },
          { title: "AEPS Transaction Reports", path: "/Agent/AEPSTransactionReports" },
          { title: "Billpayments Reports", path: "/Agent/BBPSPaymentsReports" },
          { title: "Payment Gateway Reports", path: "/Agent/PaymentGetwayReports" },
          { title: "OutStanding Reports", path: "/Agent/OutStandingReports" },
          { title: "TopUp Reports", path: "/Agent/TopUpReports" },
        ],
      },
      { title: "Balance Request", icon: <Icon.DollarSign />, path: "/Agent/BalanceRequestHistory" },
      { title: "Settings", icon: <Icon.Settings />, key: "settings",
        children: [
          { title: "Set TPIN", path: "/Agent/SetTPIN" },
          { title: "Reset TPIN", path: "/Agent/ResetTPIN" },
          { title: "Change Password", path: "/Agent/ChangePassword" },
          { title: "Raise Complaint", path: "/Agent/ComplaintListAgent" },
          { title: "Raise Complaint Bill Avenue", path: "/Agent/ComplaintListAgentBillAvenue" },
        ],
      },
      { title: "Privacy Policy", icon: <Icon.Award />, path: "/Retailer/PrivacyPolicyRetailer" },
      { title: "Terms & Condition", icon:  <Icon.Shield /> , path: "/Retailer/TermsAndConditionRetailer" },

    ],

    "5": [ // Distributor
      { title: "Dashboard", icon: <Icon.Home />, path: "/Dashboards/DistributorDashboard" },
      { title: "Add Agent", icon: <Icon.UserPlus />, path: "/Distributor/ViewRetailerDistributor" },
      { title: "Manage Credit/Debit", icon:  <Icon.Clipboard />, path: "/Distributor/ManageCreditDebitDistributor" },
      { title: "Credit Details", icon:  <Icon.Clipboard />, path: "/Distributor/CreditDetailsDistributor" },
      {
        title: "Reports",
        icon: <Icon.List />,
        key: "reports",
        children: [
          { title: "Ledger", path: "/dashboards/LedgerReportDistributor" },
          { title: "Transaction Report", path: "/Reports/DistributorDMTTransactionReports" },
          { title: "Bill Payement", path: "/Reports/DistributorBillPayementReport" },
          { title: "Commission", path: "/Reports/CommisionReportDistributor" },
          { title: "Direct TopUp Report", path: "/Distributor/DirectTopUpReports"},
        ],
      },
      { title: "Change Password", icon:  <Icon.Settings />, path: "/Distributor/ChangePasswordDistributer" },
      { title: "Self Bank Master", icon: <Icon.UploadCloud />, path: "/Distributor/DistributorBankList" },
      { title: "Balance Request", icon: <Icon.Send />, path: "/Distributor/BalanceRequestHistoryDistributor" },
    ],

    "4": [ // Super Distributor
      { title: "Dashboard", icon: <Icon.Home />, path: "/Dashboards/SuperDistributorDashboard" },
      { title: "Add Distributor", icon: <Icon.UserPlus />, path: "/dashboards/SuperViewRetailerDistributor" },
      { title: "Manage Credit/Debit", icon: <Icon.Clipboard />, path: "/dashboards/SuperManageCreditDebitDistributor" },
      { title: "Credit Details", icon: <Icon.Clipboard />, path: "/dashboards/SuperCreditDetailsDistributor" },
      { title: "Reports", icon: <Icon.List />, key: "reports",
        children: [
          { title: "Ledger", path: "/dashboards/LedgerSuperReportDistributor" },
          { title: "Business Reports", path: "/SuperDistributor/SuperDistributorBusinessReport" },
          { title: "Outstanding Reports", path: "/SuperDistributor/SuperDistributorOutStandingReports" },
          // { title: "Commission Report", path: "/dashboards/CommisionReportDistributor" },
        ],
      },
      // { title: "Commission Report", icon: <Icon.List />, path: "/dashboards/CommisionSuperReportDistributor" },
      { title: "Change Password", icon: <Icon.Home />, path: "/SuperDistributor/ChangePasswordSP" },
      { title: "Self Bank Master", icon: <Icon.Home />, path: "/SuperDistributor/SPDistributorBankList" },
      { title: "Balance Request", icon: <Icon.Home />, path: "/SuperDistributor/BalanceRequestHistorySuper" },
    ],
    
    "3": [ // Master Distributor
      { title: "Dashboard", icon: <Icon.Home />, path: "/Dashboards/MasterDistributorDashboard" },
      { title: "Add Super Distributor", icon: <Icon.UserPlus />, path: "/dashboards/MasterViewSuperDistributor"},
      { title: "Manage Credit/Debit", icon: <Icon.Clipboard />, path: "/dashboards/MasterManageCreditDebitDistributor" },
      { title: "Credit Details", icon: <Icon.Clipboard />, path: "/MasterDistributor/MasterCreditDetails" },
      { title: "Reports", icon: <Icon.List />, key: "reports",
        children: [
          { title: "Ledger Details", path: "/dashboards/LedgerMasterReportDistributor" },
          // { title: "Commission Report", path: "/dashboards/CommisionSuperReportDistributor" }
        ],
      },
      { title: "Change Password", icon: <Icon.Settings />, path: "/MasterDistributor/ChangePasswordMd" },
      { title: "Self Bank Master", icon: <Icon.UploadCloud />, path: "/MasterDistributor/MasterBankList" },
      { title: "Balance Request", icon: <Icon.Send />, path: "/MasterDistributor/BalanceRequestHistoryMaster" },
    ],

    "1": [ // Admin
      { title: "Dashboard", icon: <Icon.Home />, path: "/Dashboards/AdminDashboard"},
      { title: "User Management", icon: <Icon.User />, key: "userManagement",
        children: [
          { title: "Distributor Master", path: "/Distributor/Distributor" },
          { title: "Retailer Master", path: "/Retailer/Retailer" },
          { title: "User Service Status", path: "/Admin/UserServiceStatus" },
          { title: "User KYC Pending", path: "/Admin/PendingKycVerification" },
        ],
      },
      { title: "Balance Request", icon: <Icon.DollarSign />, path: "/Admin/ViewBalanceRequestAdmin"},
      { title: "Commission", icon: <Icon.Percent />, key: "commission",
        children: [
          { title: "Get Commission Master Template", path: "/Admin/GetCommissionMasterTemp" },
          { title: "Plan", path: "/Admin/AllPlans" },
          { title: "Commission Plan Master", path: "/Admin/GetCommissionPlanMaster" },
        ],
      },
      { title: "Credit Debit Details", icon: <Icon.CreditCard />, path: "/ManageCreditDetails/CreditDebitUsers" },
      { title: "Manage Bank", icon: <Icon.Home />, key: "bank",
        children: [
          { title: "Manage Self Bank", path: "/Admin/AdminSelfBank" },
          { title: "Manage Main Bank", path: "/Admin/MainBankList" },
          { title: "Bank Data Manager", path: "/Admin/BankDataManager" },
          { title: "Payment Operator", path: "/Admin/PaymentOperatorList" },
        ],
      },
  
      { title: "API Config", icon: <Icon.Link />, key: "apiConfig",
        children: [
          { title: "App Config", path: "/Admin/appConfig" },
          { title: "API LOGS", path: "/Admin/APILogs" },
          { title: "Web Hook", path: "/Admin/WebHook" },
          { title: "API REQ/RES BY TxnId", path: "/Admin/APIRequestResponseAdmin" },
          { title: "SMS Logs", path: "/Admin/SMSLogs" },
          { title: "Set Charges", path: "/Admin/SetCharges" },
        ],
      },
  
      { title: "Management", icon: <Icon.Settings />, key: "management",
        children: [
          { title: "Systems Setting", path: "/Admin/SystemSetting" },
          { title: "Service Control", path: "/Admin/ServicesControl" },
          { title: "Login History", path: "/Admin/LoginHistory" },
          { title: "Complaint Manager", path: "/Admin/ComplaintManager" },
          { title: "Update CustomerLimit", path: "/Admin/CustomerLimitInc" },
          { title: "Update Customer Name", path: "/Admin/CustomerNameUpdate" },
          { title: "Change Tpin", path: "/Admin/ChangeTpin" },
          { title: "Notification", path: "/Admin/Notification" },
        ],
      },
      { title: "Contact Us Users", icon: <Icon.Users />, path: "/Admin/ContactUsUsers" },
      { title: "Reports", icon: <Icon.BarChart />, key: "reports",
        children: [
          { title: "User Ledger Reports", path: "/Admin/AdminLedgeReports" },
          { title: "ADMIN Ledger Reports", path: "/Admin/AdminSelfLedger" },
          { title: "Payout Transaction Reports", path: "/Admin/PayOutTransactionReports" },
          { title: "Commission Transaction Reports", path: "/Admin/CommissionTransectionReports" },
          { title: "Transaction Reports", path: "/Reports/GetDMTTransactionReports" },
          { title: "Cashout Transaction", path: "/Reports/CashoutTransactionReportsAdmin" },
          { title: "Refund Report", path: "/Reports/RefundReportAdmin" },
          { title: "Bill Payment Reports", path: "/Reports/AdminBillPaymentReports" },
          { title: "AEPS Transaction Reports", path: "/Reports/AEPSTransactionReportsAdmin" },
          { title: "Pending Transaction Reports", path: "/Reports/PendingTransactionReports" },
          { title: "Failed Transaction Reports", path: "/Reports/FailedTransactionReports" },
          { title: "User Ledger Reconcile Reports", path: "/Admin/AdminLedgeReconsileReports" },
          { title: "Daily Payout/PayIn Report", path: "/Reports/DaileyTrasactionReports" },
          { title: "Change Status By Txn Id", path: "/Admin/AdminChangeStatus" },
          { title: "API Request Response Status", path: "/Admin/APIRequestResponseAdmin" },
          { title: "Payment Gateway Transaction Report", path: "/Reports/AdminPaymentGetwayTransactionReport" },
          { title: "Top Up Report", path: "/Reports/AdminTopUpReport" },
          { title: "Daily Business Reports", path: "/Reports/AdminDailyBusinessReports" },
          { title: "Account Status Report", path: "/Reports/AccountStatusReports" },
          { title: "Business Report", path: "/Admin/AdminBusinessReports" },
          { title: "Business Analysis Report", path: "/Admin/AdminBusinessReport" },
        ],
      },
    ],

  }), []);

  const renderMenu = (menus) => {
    return menus.map((item, index) => {
      // 🔹 Simple Link
      if (!item.children) {
        return (
          <NavItem key={index}>
            <NavLink tag={Link} to={item.path} className={`gap-2 ${ location.pathname === item.path ? "activeLink" : ""}`}>
              <span className="sidebarIcon">{item.icon}</span>
              <span className="hide-mini">{item.title}</span>
            </NavLink>
          </NavItem>
        );
      }

      return (
        <NavItem key={index} className={openMenu === item.key ? "activeParent" : ""}>
          <NavLink className="cursor-pointer gap-2" onClick={() => toggleMenu(item.key)}>
            <span className="sidebarIcon">{item.icon}</span>
            <span className="w-100 d-flex justify-content-between hide-mini">
              {item.title}
              <i className={`bi ${ openMenu === item.key ? "bi-chevron-down" : "bi-chevron-right"}`} />
            </span>
          </NavLink>

          <Collapse isOpen={openMenu === item.key}>
            {item.children.map((sub, i) => (
              <NavItem key={i}>
                <NavLink tag={Link} to={sub.path} className={`gap-2 ${ location.pathname === sub.path ? "activeLink" : ""}`}>
                  <span className="sidebarIcon">
                    <Icon.ChevronRight />
                  </span>
                  <span>{sub.title}</span>
                </NavLink>
              </NavItem>
            ))}
          </Collapse>
        </NavItem>
      );
    });
  };

  return (
    <div className={`sidebarBox ${isFixed ? "fixedSidebar" : ""}`}>
      <SimpleBar style={{ height: "100%" }}>
        <div className="mb-4 pb-5 mt-1">
          <Nav vertical className={activeBg === "white" ? "" : "lightText"}>
            {!currentUser?.kycStatus ? (
              <h3 className="text-warning ms-3">User KYC is Pending</h3>
            ) : (
              <>
                {menuConfig[currentUser?.role]?.length ? renderMenu(menuConfig[currentUser.role]) : <h5 className="ms-3">No Menu Found</h5>}
                {currentUser?.role === "6" && <NavItem>
                  <NavLink onClick={handleLogoutClick} className="gap-2">
                    <span className="sidebarIcon">
                      <Icon.LogOut />
                    </span>
                    <span>Logout</span>
                  </NavLink>
                </NavItem>
               }
              </>
            )}
          </Nav>
        </div>
      </SimpleBar>
    </div>
  );
};

export default Sidebar;